export enum MultipleLoanEligibilityRule {
    IN_PROGRESS_LOAN_APPLICATION = 'IN_PROGRESS_LOAN_APPLICATION', IN_PROGRESS_LOAN = 'IN_PROGRESS_LOAN',
    OUTSTANDING_PRINCIPAL_LIMIT = 'OUTSTANDING_PRINCIPAL_LIMIT', AGE_LIMIT = 'AGE_LIMIT',
    ACTIVE_LOAN_EMI_DELAY = 'ACTIVE_LOAN_EMI_DELAY', IEC_CHECK_LOAN_APPLICATION = 'IEC_CHECK_LOAN_APPLICATION',
    NO_EXISTING_BAD_LOAN = 'NO_EXISTING_BAD_LOAN', ACTIVE_PRE_APPROVED_LOAN_OFFER = 'ACTIVE_PRE_APPROVED_LOAN_OFFER'
}

export interface MultipleLoanEligibilityCheck {
    rule: MultipleLoanEligibilityRule;
    isValid: boolean;
    maximumLoanAmount?;
    eligibleLoanAmount?;
    totalPrincipalOutstandingOfDisbursedLoans?;
    totalLoanAmountOfYetToBeDisbursedLoans?;
}

export interface MultipleLoanEligibilityCheckResponse {
    isEligible: boolean;
    checks: MultipleLoanEligibilityCheck[];
}
